export default __webpack_public_path__ + "static/media/google.a98e945e.gif";